import { NgModule } from '@angular/core';
import { AccessCodesService } from '@shared/services/api/legacy/accesscodes-service/accesscodes.service';
import { AllocationsService } from '@shared/services/api/legacy/allocations-service/allocations.service';
import { AttendeesService } from '@shared/services/api/legacy/attendees-service/attendees-service';
import { ContactColumnsService } from '@shared/services/api/legacy/contactcolumns-service/contactcolumns.service';
import { ContactCustomFieldsService } from '@shared/services/api/legacy/contactcustomfields-service/contactcustomfields.service';
    import { ContactQueriesService } from '@shared/services/api/legacy/contactqueries-service/contactqueries.service';
import { ContactsService } from '@shared/services/api/legacy/contacts-service/contacts.service';
import { ContacttagsService } from '@shared/services/api/legacy/contacttags-service/contacttags.service';
import { EventEmailsService } from '@shared/services/api/legacy/eventemails-service/eventemails.service';
import { EventPagesService } from '@shared/services/api/legacy/eventpages-service/eventpages.service';
import { EventsService } from '@shared/services/api/legacy/events-service/events.service';
import { ExcelService } from '@shared/services/api/legacy/excel-service/excel.service';
import { FacilitiesService } from '@shared/services/api/legacy/facilities-service/facilities.service';
import { FrontdeskUsersService } from '@shared/services/api/legacy/frontdeskusers-service/frontdeskusers.service';
import { HubspotListsService } from '@shared/services/api/legacy/hubspotlists-service/hubspotlists.service';
import { ImportsService } from '@shared/services/api/legacy/imports-service/imports.service';
import { InvitationsService } from '@shared/services/api/legacy/invitations-service/invitations.service';
import { InvitedeskApiService } from '@shared/services/api/legacy/invitedesk-api.service';
import { LanguagesService } from '@shared/services/api/legacy/languages-service/languages.service';
import { MultiTenantLoginsService } from '@shared/services/api/legacy/multitenantlogin-service/multitenantlogins.service';
import { PersonsService } from '@shared/services/api/legacy/persons-service/persons-service';
import { PublicPagesService } from '@shared/services/api/legacy/publicpages-service/publicpages-service';
import { ReportsService } from '@shared/services/api/legacy/reports-service/reports.service';
import { RolesService } from '@shared/services/api/legacy/roles-service/roles.service';
import { SurveyService } from '@shared/services/api/legacy/survey-service/survey.service';
import { TemplatesService } from '@shared/services/api/legacy/templates-service/templates.service';
import { TicketsService } from '@shared/services/api/legacy/tickets-service/tickets.service';
import { TimelinesService } from '@shared/services/api/legacy/timelines-service/timelines.service';
import { UploadsService } from '@shared/services/api/legacy/uploads-service/uploads.service';
import { UserColumnsService } from '@shared/services/api/legacy/usercolumns-service/usercolumns.service';
import { UsersService } from '@shared/services/api/legacy/users-service/users.service';
import { MarketoListsService } from './marketolists-service/marketolists.service';
import { LiveWebinarsService } from './livewebinars-service/livewebinars.service';
import { CustomDomainsService } from './customdomains-service/customdomains-service';
import { HubspotService } from './hubspot-service/hubspot.service';
import { MailStatusesService } from './mailstatuses-service/mailstatuses.service';
import { CampaignsService } from './campaigns-service/campaigns.service';
import { UnsubscribeService } from './unsubscribe-service/unsubscribe.service';
import { WebhooksService } from './webhooks-service/webhooks.service';
import { ApiKeysService } from './apikeys-service/apikeys.service';
import { NotesService } from './notes-service/notes.service';
import { AttendeeNotesService } from './attendeenotes-service/attendeenotes-service';

@NgModule({
  providers: [
      InvitedeskApiService,
      PersonsService,
      RolesService,
      UsersService,
      LanguagesService,
      EventsService,
      FacilitiesService,
      TemplatesService,
      PublicPagesService,
      ContactsService,
      ContactQueriesService,
      ContactColumnsService,
      TimelinesService,
      EventPagesService,
      EventEmailsService,
      ImportsService,
      AllocationsService,
      InvitationsService,
      AttendeesService,
      ExcelService,
      UploadsService,
      MultiTenantLoginsService,
      ReportsService,
      TicketsService,
      FrontdeskUsersService,
      AccessCodesService,
      ContactCustomFieldsService,
      ContacttagsService,
      SurveyService,
      UserColumnsService,
      HubspotListsService,
      MarketoListsService,
      LiveWebinarsService,
      CustomDomainsService,
      HubspotService,
      MailStatusesService,
      CampaignsService,
      UnsubscribeService,
      WebhooksService,
      ApiKeysService,
      NotesService,
      AttendeeNotesService
    ]
})
class InvitedeskApiModule { }

export { InvitedeskApiModule };
